import Image from "next/image";
import { FC } from "react";

import getPositionClass from "@/utils/getPositionClass";

interface CardImageTextProps {
  src: string;
  altText: string;
  position: string;
  titleText: string;
  descriptionText?: string;
  textColor?: string;
  ratio: "3:4" | "4:3";
  gradient?: boolean;
  width?: number;
  height?: number;
  titleColor?: string;
}

const CardImageText: FC<CardImageTextProps> = ({
  src,
  altText,
  position,
  titleText,
  descriptionText,
  textColor,
  ratio,
  gradient,
  width,
  height,
  titleColor,
}) => {
  return (
    <div className={`h-CardGallery md:h-CardGalleryDesktop ${ratio === "3:4" ? "aspect-3-4" : "aspect-4-3"} flex ${getPositionClass(position)}`}>
      <Image className="absolute object-cover w-full h-full rounded-md" src={src} alt={altText} width={width} height={height} />
      {gradient && <div className="img-overlay-5 absolute top-0 left-0 bottom-0 right-0"></div>}
      <div className={`w-full z-10 pb-xl pt-xl accent-color`} style={{ "--font-accent-color": textColor } as React.CSSProperties}>
        <p
          className="font-primary text-[24px] w-22\/24 mx-auto font-normal text-center pb-s uppercase accent-font accent-title"
          style={{ color: `${titleColor ? titleColor : ""}` }}
        >
          {titleText}
        </p>
        <p className="text-m font-secondary w-22\/24 mx-auto font-medium  text-center">{descriptionText}</p>
      </div>
    </div>
  );
};
export default CardImageText;
